<template>
  <div class="field">
    <label v-if="label !== undefined" :for="name"> {{ label }}</label>
    <Field
      :id="name"
      as="input"
      :type="type"
      :name="name"
      :rules="rules"
      :placeholder="placeholder"
      v-model="localValue"
    />
    <ErrorMessage :name="name"/>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
import { computed } from 'vue'

export default {
  name: 'LabeledInput',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    rules: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: true
    }
  },
  components: {
    Field, ErrorMessage
  },
  setup (props, { emit }) {
    const localValue = computed({
      get () {
        return props.modelValue
      },
      set (value) {
        emit('update:modelValue', value)
      }
    })
    return {
      localValue
    }
  }
}
</script>

<style lang="scss" scoped>

.field {
  position: relative;
  padding: 4px 0;

  input, label {
    display: block;
  }

  label {
    color: #222;
  }

  input {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #717171;
    border-radius: 5px;
    padding: 11px 10px;
    position: relative;
  }

  span {
    position: absolute;
    color: red;
    font-size: 0.75em;
    display: flex;
    justify-content: flex-end;
    right: 0;
  }
}
</style>
